import { render, staticRenderFns } from "./CourseDetailsOrganization.vue?vue&type=template&id=5dd18994&scoped=true&"
import script from "./CourseDetailsOrganization.vue?vue&type=script&lang=js&"
export * from "./CourseDetailsOrganization.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailsOrganization.vue?vue&type=style&index=0&id=5dd18994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd18994",
  null
  
)

export default component.exports